import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {SettingType} from '@di-shared/api/di/type';
import {useQuery} from '@tanstack/react-query';
import {useEffect, useState} from 'react';

const SESSION_STORAGE_HISTORY_UNLOCK = 'isHistoryUnlocked';

export function setSessionIsHistoryUnlock(isUnlocked: boolean) {
  sessionStorage.setItem(SESSION_STORAGE_HISTORY_UNLOCK, JSON.stringify(isUnlocked));
}

export function getSessionIsHistoryUnlock() {
  const status = sessionStorage.getItem(SESSION_STORAGE_HISTORY_UNLOCK);
  return status ? JSON.parse(status) : status;
}

export default function useHistoryLock({vin}: {vin: string}) {
  const [isHistoryUnlock, setIsHistoryUnlock] = useState<boolean | null>(null);
  const {data: lockData, isError} = useQuery({
    queryKey: [getQueryKey(diApi.vehicleSettingController.getVehicleSetting), vin, SettingType.LOCK_DRIVE_RECORD],
    queryFn: () =>
      diApi.vehicleSettingController.getVehicleSetting({
        vin,
        settingType: SettingType.LOCK_DRIVE_RECORD,
      }),
    select: ({data}) => data,
  });

  useEffect(() => {
    if (!lockData) {
      return;
    }
    if (getSessionIsHistoryUnlock() === null) {
      setSessionIsHistoryUnlock(!lockData.enabled);
      setIsHistoryUnlock(!lockData.enabled);
    } else {
      setIsHistoryUnlock(getSessionIsHistoryUnlock());
    }
  }, [lockData]);

  if (!lockData || isError) {
    return {
      isHistoryUnlock: null,
      unlock: () => {},
      isError,
    };
  }

  function unlock() {
    setSessionIsHistoryUnlock(true);
    setIsHistoryUnlock(true);
  }

  return {
    isHistoryUnlock,
    unlock,
    isError,
  };
}
